module.exports = __webpack_public_path__ + "static/img/318.08ec8f07.jpg";